import {ClockType} from '@/common/constants/units';

export function hourReduce(hour: number, unit: ClockType) {
	switch (unit) {
		case ClockType['24h']:
			return `${hour}:00`;

		case ClockType['12h']: {
			return new Date(0, 0, 0, hour).toLocaleTimeString('en', {hour: 'numeric'}).toLowerCase();
		}
	}
}
